import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { selectPricingState } from ".";

// Sélecteurs individuels pour faciliter l'utilisation
export const selectFunnels = createSelector(
  [selectPricingState],
  (pricingState) => pricingState.funnels
)

// Sélecteurs individuels pour faciliter l'utilisation
export const selectContractFunnels = createSelector(
  [selectPricingState],
  (pricingState) => pricingState.contractFunnels
)

// Sélecteur pour récupérer un ContractFunnel par ID avec priorité aux updatedContractFunnels
export const selectContractFunnelById = (contractFunnelId: string, contractIdentifier?: string) => (state: RootState) => {
  const { contractFunnels, updatedContractFunnels } = state.pricing;

  // 1. Chercher d'abord dans updatedContractFunnels (priorité)
  if (updatedContractFunnels && updatedContractFunnels.length > 0) {
    const updatedContractFunnel = updatedContractFunnels.find(
      ucf => ucf.id === contractFunnelId && ucf.contractIdentifier === contractIdentifier
    );

    if (updatedContractFunnel) {
      return {
        isEditMode: true,
        contractFunnel: updatedContractFunnel,
      };
    }
  }

  // 2. Si pas trouvé, chercher dans contractFunnels
  const originalContractFunnel = contractFunnels.find(
    cf => cf.id === contractFunnelId && cf.contractIdentifier === contractIdentifier
  );

  return {
    isEditMode: false,
    contractFunnel: originalContractFunnel || null,
  };
};

